import React from 'react';
import ReactDOM from 'react-dom/client';
import GuidedHelp from './components/GuidedHelp';

const $root: HTMLElement | null = document.getElementById( 'timken-guided-help-app' );

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<GuidedHelp />
		</React.StrictMode>
	);
}
